export default __webpack_public_path__ + "static/media/arrow_up_beci.ae8bf85c.svg";